<template>
  <Pagebody :loading='false' :subnav="[]">
    <div style='padding: 21px 26px;'>
        <div class="risk-box">
            <p>您购买小超市软件使用授权之前，必须仔细阅读下面的内容，以便全面地了解使用软件的风险。</p>
            <p>
                <common-data name="appFullName_10"/>、<common-data name="appFullName_12"/>、趋势策略量化软件、订单流策略量化软件、多因子量化策略软件由上海文华财经资讯股份有限公司开发和运营（若非付款时特别指定可在境外使用其它情况都默认为软件所含数据及新闻信息等仅限在中国大陆范围内使用），在交易所的行情发布许可授权下，专线接入交所获取行情数据，交易网关后台对接证券/期货公司的交易结算系统的开放接口。软件系统已经尽可能采取有效措施保护交易活动的安全，尽管如此，本着对用户负责的态度，在此提醒用户，使用本软件存在且不限于下列风险：
            </p>
            <p>
                （一）在不限于以下故障情况出现时，可能会使您的委托指令无法发出，或产生错误指令：
            </p>
            <p>
                （1）系统与交易所、证券/期货公司的远程数据通讯线路发生故障，而交易所还在正常进行交易。
            </p>
            <p>
                （2）系统的计算机设备出现故障，而交易所还在正常进行交易。
            </p>
            <p>
                （3）用户交易终端与后台系统的通讯线路发生故障，而证券/期货公司和交易所还在正常交易。
            </p>
            <p>
                （4）突然停电而导致计算机系统中断。
            </p>
            <p>
                （5）用户在交易过程中因自身原因进行的误操作。
            </p>
            <p>
                （6）用户设置好程序化以后，退出软件或关机。
            </p>
            <p>
                （7）其他不可预测的系统风险或者技术风险。
            </p>
            <p>
                （二）委托交易的数据传输可能因通讯繁忙或丢包等原因出现中断、停顿、延迟、数据错误、丢失或不完全，造成交易出现延迟、停顿、中断，从而会发生您不能及时、完整完成交易的风险。因此，您在使用该软件时，及时查证核实成交情况。
            </p>
            <p>
                （三）由于出现网络故障或网络繁忙或交易网关负载过重，或因受到网络黑客、网络病毒的攻击和入侵等原因，软件可能会出现故障，您可能不能及时进入或通过该系统进行正常交易，或接到错误信息，或不能使用软件提供的全部或部分功能（包括但不限于各种自助和预设触发条件的下单功能等）。鉴于上述风险的存在，您在使用本软件的时候，应当使用其它信息系统或其它交易手段进行验证，并及时查证成交情况。
            </p>
            <p>
                （四）由于您开立的证券/期货交易账户交由他人使用，出现未按您本人意图买卖证券/期货合约和提取资金的情况，所产生的后果由您本人承担。
            </p>
            <p>
                （五）云端交易只是文华提供的一项软件功能便利，在服务器、网络、软件等故障导致功能失效的情况下，由用户自己承担由此引起的交易损失。
            </p>
            <p>
                （六）条件单和止损单，设定委托发出的条件，当条件满足时，交易系统将委托单自动报入交易所，当条件不满足时，委托单保留在云端服务器中。
            </p>
            <p>
                （七）程序化模型所发出买卖讯号之建议，乃依据特定数学公式计算所得结果，仅供交易参考，据此入市，盈亏自负。
            </p>
            <p>
                （八）软件的条件单、止损单、程序化交易，对操作者有一定的交易经验与基础要求，请慎重考虑使用。
            </p>
            <p>
                （九）由于交易所交易规则所限，软件中包括但不限于各种自助和预设触发条件的下单功能所发生的交易委托不一定能够成交。
            </p>
            <p>
                （十）软件发布的行情信息及其它证券/期货信息，因为网络延时等原因有可能出现错误或被误导，从而导致您做出错误判断，因此，您在使用该软件时，应对比其他软件，或采用其它手段，并及时查对行情数据。
            </p>
            <p>
                （十一）由于用户对开户资料、交易账户、交易密码等重要资料保护不当，造成被他人盗用，仿冒而产生的亏损由用户自己负责。
            </p>
            <p>
                本揭示书未能尽述一切有关软件电子交易风险的重要事项，用户应该在细心研究、熟悉软件后，方可使用。
            </p>
            <p>
                证券/期货公司和文华财经，都不会因为您购买小超市软件使用授权而造成的损失承担责任。
            </p>
        </div>
        <div class="warn">* 使用软件有风险，我司不对由于软件或网络导致任何损失进行赔偿。</div>
    </div>
  </Pagebody>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Risk',
  components: {
    
  }
}
</script>

<style scoped>
.risk-box{
    font-size: 14px;
    color: #888886;
    padding: 16px 32px;
}
.warn{
    margin-top: 10px;
    color: red;
    height: 30px;
    line-height: 30px;
}
</style>